module.exports = __webpack_public_path__ + "img/StartEvent.51104a06.svg";